export interface OrdersTableColumn {
    field: string;
    headerName: string;
    variant: BarekamColumns | WarehouseWorkerColumns,
    removeInTablet?: boolean;
    removeInMobile?: boolean;
}

export enum BarekamColumns {
    barekamTrack = 'barekam_track',
    checkbox = 'checkbox',
    progress = 'progress',
    text = 'text',
    paymentStatus = 'paymentStatus',
    date = 'date',
    orderDate = 'orderDate',
    money = 'money',
    discount = 'discount',
    recipient = 'recipient',
    sender = 'sender',
    trackRecord = 'trackRecord',
    trackStatus ='trackStatus',
    warehouse = 'warehouse',
    firstWarehouse = 'firstWarehouse',
    price = 'price',
    weight = 'weight',
    productWeight = 'productWeight',
    productCount = 'productCount',
    productPrice = 'productPrice',
    productTrackNumbers = 'productTrackNumbers',
    actions = 'actions',
    shippingCategory = 'shippingCategory',
    additionalServices = 'additionalServices',
    lastActionDate = 'lastActionDate',
    deliveredDate = 'updateOn',
}

export enum WarehouseWorkerColumns {
    location = 'location',
    group = 'group',
    list = 'list',

    inWarehouseActions = 'inWarehouseActions',
    readyForShipmentActions = 'readyForShipmentActions',
    inLocalWarehouseActions = 'inLocalWarehouseActions',
    onTheWayActions = 'onTheWayActions',
    unidentifiedActions = 'unidentifiedActions',
    readyForPickupActions = 'readyForPickupActions',
    bulkActionPopupActions = 'bulkActionPopupActions',
    allOrdersActions = 'allOrdersActions',
}